import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ForgeModules } from './ForgeModules.ts';
import type { RenderForgeExtensions } from './main.tsx';

export const lazyForgeUIExtensionsWithLoader = (
	loadingComponent: any,
): LoadableType<{
	moduleType: ForgeModules;
	render: RenderForgeExtensions;
	returnBlockedExtensions?: boolean;
	spaceContextOnly?: boolean;
	contentId?: string;
	spaceKey?: string;
	localId?: string;
}> =>
	LoadableAfterPaint({
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-ForgeUIExtensionsWrapper" */ './main.tsx'))
				.ForgeUIExtensionsWrapper,
		loading: loadingComponent,
	});

export const LazyForgeUIExtensions: LoadableType<{
	moduleType: ForgeModules;
	render: RenderForgeExtensions;
	returnBlockedExtensions?: boolean;
	spaceContextOnly?: boolean;
	contentId?: string;
	spaceKey?: string;
	localId?: string;
}> = lazyForgeUIExtensionsWithLoader(undefined);
